import {AbstractWallet} from '@/mobipoints/wallet/abstract_wallet.type';

export class WalletMobiPoints extends AbstractWallet{
}